import type {
    TabBarScrollConstantType,
    TabBarSlotsConstantType,
    TabBarScrollStateType,
    TabBarSlotsType
} from "./type";
import {
    TAB_BAR_MAX_ITEMS
} from "./stylesheet";

export const getTabBarSlots = ({
    activeKey,
    items
}: TabBarSlotsConstantType): TabBarSlotsType => {
    const currentKey = activeKey ?? items.find((item) => item.isActive)?.key;

    if(items.length <= TAB_BAR_MAX_ITEMS) {
        return {
            isMoreActive: false,
            visibleItems: items,
            overflowItems: [],
            currentKey
        };
    }

    const overflowItems = items.slice(TAB_BAR_MAX_ITEMS - 1);

    return {
        isMoreActive: overflowItems.some((item) => item.key === currentKey),
        visibleItems: items.slice(0, TAB_BAR_MAX_ITEMS - 1),
        overflowItems,
        currentKey
    };
};

export const getTabBarScrollState = ({
    contentHeight,
    previousState,
    layoutHeight,
    threshold,
    offset
}: TabBarScrollConstantType): TabBarScrollStateType => {
    if(offset <= 0 || offset >= contentHeight - layoutHeight) {
        return {
            anchorOffset: offset,
            isHidden: false
        };
    }

    const delta = offset - previousState.anchorOffset;

    if(Math.abs(delta) <= threshold) {
        return previousState;
    }

    return {
        anchorOffset: offset,
        isHidden: delta > 0
    };
};
